export let hc_ds = {
    'vars': {},
    'tests': null,
    'settings': {
        serviceURL: process.env.DS_serviceURL,
        jwtURL: process.env.DS_jwtURL
    },
    'status': {
        "9": "User details retrieved",
        "18": "Windcave session created",
        "27": "User navigated to Windcave",
        "36": "Payment successful",
        "38": "Payment cancelled",
        "40": "Payment failed"
    }
};


/*
----------------------------
Module - Datastore
----------------------------
*/
hc_ds.fn = {
    // get all data for a collection
    "getAllData": async function (settings){
        let collection = hccosp.Datastore.collection(settings.conf.collection);
        return await collection.get();
    },
    "genericDataLogger": function (endpoint){
        let collection = hccosp.Datastore.collection(endpoint);
        collection.get().then((response) => {
            console.log(response);
        });
    },
    // search collection
    "lookupData": async function (settings){
        let collection = hccosp.Datastore.collection(settings.conf.collection);
        let lookupArr = settings.lookup;
        if(lookupArr.length > 0){
            for(let index = 0; index < lookupArr.length; index++){
                const lookupValue = lookupArr[index].value;
                if(index === 0){
                    collection.where(lookupArr[index].key, lookupArr[index].comparison, lookupValue);
                } else {
                    if(typeof lookupArr[index].logic != "undefined" && lookupArr[index].logic === 'or'){
                        collection.or(lookupArr[index].key, lookupArr[index].comparison, lookupValue);
                    } else {
                        collection.and(lookupArr[index].key, lookupArr[index].comparison, lookupValue);
                    }
                    
                }
            }
        }
        return await collection.get();
    },
    // get a document
    "getData": async function (settings){
        const lookupValue = settings.conf.dsId.toUpperCase();
        const collection = hccosp.Datastore.collection(settings.conf.collection).doc(lookupValue);
        return await collection.get();
    },
    // update a document
    "setData": async function (settings){
        settings.data.progressDateUTC = Number(Date.now().toString().slice(0,10));
        let collection = hccosp.Datastore.collection(settings.conf.collection).doc(settings.conf.dsId);
        return await collection.update(settings.data);
    },
    // add a document
    "addData": async function (settings){
        let collection = hccosp.Datastore.collection(settings.conf.collection);
        return await collection.add(settings.data, settings.conf.dsId);
    },
    // delete a record
    // hc_ds.fn.deleteData('fines', '')
    "deleteData": async function (col,dsId){
        let collection = hccosp.Datastore.collection(col).doc(dsId);
        return await collection.delete();
    },
    // init datastore
    "init": function(){
        hccosp.Datastore = new Datastore(hc_ds.settings);

        if (typeof hccosp.Datastore === 'undefined') {
            //console.log('DS init - DS not found');
            return;
        }
        // simulator
        //hccosp.Datastore.setSetting('jwtPayload', { userid: process.env.DS_jwtREF });

    }
};


